
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwimming as ObiSwimmingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-swimming.js';
 
 
 

 
 export const ObiSwimming = createComponent({
   react: React,
   tagName: 'obi-swimming',
   elementClass: ObiSwimmingElement,
   events: {
     
   }
  });
 
 